﻿import { IProject } from "@/interfaces";
import { useUserContext } from "@/providers";
import { calculateIsUserProjectTeamMember } from "@/providers/helpers";

export function useIsTeamMember(projectLoading: boolean, project: IProject) {
  const { userToken } = useUserContext();
  return calculateIsUserProjectTeamMember(projectLoading, project, userToken);
}
